<template>
    <div>
        <dashboard-notes-activity-card
                v-if="hasPremiumSubscription"
                class="mb-6">
        </dashboard-notes-activity-card>
        
        <profile-block></profile-block>
        <updates-block class="mt-6"></updates-block>
        <concurrent-block class="mt-6"></concurrent-block>
    </div>
</template>

<script>
    import ProfileBlock from './ProfileBlock.vue';
    import UpdatesBlock from './UpdatesBlock.vue';
    import ConcurrentBlock from './ConcurrentBlock.vue';
    import OutlinedCard from "../../../components/cards/OutlinedCard.vue";
    import DashboardNotesActivityCard from "./DashboardNotesActivityCard.vue";

    export default {
        components: {
            DashboardNotesActivityCard,
            OutlinedCard,
            ProfileBlock,
            UpdatesBlock,
            ConcurrentBlock
        }
    }
</script>